import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { toggleLeftMenu } from '../../actions/layout';
import Paper from 'material-ui/Paper';
import AppBar from 'material-ui/AppBar';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/svg-icons/navigation/menu';
import withWidth, { LARGE } from 'material-ui/utils/withWidth';

export class LoggedAppBar extends React.Component {
  static propTypes = Object.assign({}, AppBar.propTypes, {
    isStatic: PropTypes.bool.isRequired,
    width: PropTypes.number.isRequired,
    toggleLeftMenu: PropTypes.func.isRequired,
    children: PropTypes.node,
    childrenHeight: PropTypes.number.isRequired
  });

  static defaultProps = {
    childrenHeight: 0,
    isStatic: false
  };

  static contextTypes = {
    muiTheme: PropTypes.object
  };

  render() {
    let {toggleLeftMenu, style, width, isStatic, children, childrenHeight = 0, ...other} = this.props;
    let {navBar, palette: {labelColor}} = this.context.muiTheme;
    let isLarge = width === LARGE;

    let fixedStyle = {
      width: 'auto',
      position: 'fixed',
      top: 0,
      right: 0,
      zIndex: 10,
      left: isLarge ? navBar.openedWidth : 0
    };

    const height = childrenHeight + 64;

    return !isLarge || isStatic
      ? (
      <div>
        <Paper zDepth={2} style={fixedStyle}>
        <AppBar style={style}
                {...other}
                titleStyle={{color: labelColor}}
                zDepth={0}
                iconStyleLeft={isLarge ? {display: 'none'} : null}
                iconElementLeft={
                  isLarge
                    ? (<IconButton></IconButton>)
                    : (
                    <IconButton onClick={toggleLeftMenu}>
                      <IconMenu color="white"/>
                    </IconButton>
                  )
                }
        />
          <div>
          {children}
          </div>
        </Paper>
        <div style={{height}}></div>
      </div>
    )
      : null;
  }
}

export default connect(
  undefined,
  (dispatch) => ({
    toggleLeftMenu: () => dispatch(toggleLeftMenu())
  })
)(withWidth()(LoggedAppBar));





// WEBPACK FOOTER //
// ./src/components/LoggedLayout/LoggedAppBar.js